import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTime } from "../../store/fullLengthExam";
import RxStopwatch from "../../constants/icons/Rx/RxStopwatch";

const TimerComponent = ({ onTimerEnd, initialTime, currentSectionIndex }) => {
  const dispatch = useDispatch();
  const [showTimer, setShowTimer] = useState(true);
  const [timer, setTimer] = useState(230);
  const [buttonText, setButtonText] = useState("Hide");

  useEffect(() => {
    setTimer(initialTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSectionIndex]);

  useEffect(() => {
    dispatch(setTime(timer));
  }, [timer, onTimerEnd, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevCount) => {
        if (prevCount > 0) {
          return prevCount - 1;
        } else {
          clearInterval(interval);
          onTimerEnd();
          return 0;
        }
      });
    }, 1000);
    // Cleanup interval on component unmount to prevent multiple intervals
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatTime = (time) => {
    try {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    } catch (err) {
      return "00:00";
    }
  };

  const toggleTimerVisibility = () => {
    setShowTimer(!showTimer);
    setButtonText(showTimer ? "Show" : "Hide");
  };

  return (
    <div className="d-flex justify-content-center flex-column align-items-center">
      {showTimer ? (
        <div style={{ fontWeight: "bold", fontSize: "18px", color: "#39393B" }}>
          {formatTime(timer)}
        </div>
      ) : (
        <div style={{ fontWeight: "bold", fontSize: "18px", color: "#39393B" }}>
          <RxStopwatch
            size={16}
            style={{
              fontWeight: 800,
              color: "black",
            }}
          />
        </div>
      )}

      <button
        style={{
          width: 68,
          height: 27,
          left: 0,
          top: 0,
          textAlign: "center",
          color: "black",
          fontSize: 16,
          fontFamily: "Inter",
          fontWeight: "600",
          wordWrap: "break-word",
          cursor: "pointer", // Add cursor pointer'
          border: "1px solid black",
          borderRadius: "15px",
        }}
        onClick={toggleTimerVisibility}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default TimerComponent;
